import { render, staticRenderFns } from "./SubscriptionGiftCouponList.vue?vue&type=template&id=906c2fc2&lang=pug&"
import script from "./SubscriptionGiftCouponList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionGiftCouponList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports